import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from "./home/home.component";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'doctors',
    loadChildren: () =>
        import('./doctors/doctors.module').then((m) => m.DoctorsModule),
  },
  {
    path: 'patients',
    loadChildren: () =>
        import('./patient/patient.module').then((m) => m.PatientModule),
  },
  {
    path: 'portail',
    loadChildren: () =>
        import('./home/portail.module').then((m) => m.PortailModule),
  },
  {
    path: 'laboratories',
    loadChildren: () =>
        import('./laboratories/laboratories.module').then((m) => m.LaboratoriesModule),
  }, {
    path: 'footer',
    loadChildren: () =>
        import('./commons/footer/footer.module').then((m) => m.FooterModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash : true
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
